import { render, staticRenderFns } from "./ShemaCell.vue?vue&type=template&id=05e64424&"
import script from "./ShemaCell.vue?vue&type=script&lang=js&"
export * from "./ShemaCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports